import styled from 'styled-components';

export const DwollaContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Container = styled.div`
  position: relative;
  width: 100%;
  .dwolla-iav-text-box {
  width: 100% !important;
  min-height: 50px;
  background-color: #F2F2F2;
  border-radius: 2px;
  outline: none;
  border: none;
  font-size: 15px;
  line-height: 24px;
  font-family: PublicSans-Regular;
  color: #101011;
  padding: 0 20px;
  box-shadow: none !important;
  margin-bottom: 20px;
}

 .dwolla-iav-text-box::placeholder {
    font-size: 15px;
    line-height: 24px;
    font-family: PublicSans-Regular;
    color: #101011;
  }

p.dwolla-iav-text {
  font-size: 15px;
  line-height: 24px;
  font-family: PublicSans-Regular;
  color: #000000;
}

p.disclaimer {
  font-size: 9px;
  line-height: 13px;
  color: #58585B;
  font-family: PublicSans-Regular;
}

.yodlee-check-image {
  display: none;
}

.dropdown-input {
  background-color: #F2F2F2;
}

.pointerevents .dropdown-input:before {
   background-color: #F2F2F2;
}

.fields-list flex one-col:last-child {
   margin-bottom: 0px !important;
}

.form-fields > div:last-child input {
   margin-bottom: 0px !important;
}

.footnote {
  font-size: 10px;
  line-height: 14px;
  color: #58585B;
  font-family: PublicSans-Regular;
}

.island__callout.yodlee-bank-logo {
  margin-bottom: 0 !important;
}

@media screen and (max-width:410px) {
  .dwolla-iav-text-box {
    max-width: unset;
    font-size: 16px !important;
  }
}

.fields-list.flex {
   flex-direction: column-reverse;
}

.yodlee-form .form-fields>div label {
  display: none;
}

.yodlee-form .form-fields>div {
  margin-bottom: 0 !important;
}

.dwolla-iav-back-button {
  width: calc(100% - 2px) !important;
  min-height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  cursor: pointer;
  background-color: white;
  font-size: 12px;
  line-height: 150%;
  font-family: PublicSans-Regular;
  text-align: center;
  color: #464648;
  text-align: center;
}

.dwolla-iav-button {
  width: 100% !important;
  min-height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  cursor: pointer;
  border: none;
  background-color: rgb(16, 57, 221);
  font-size: 16px;
  line-height: 21px;
  font-family: PublicSans-Bold;
  text-align: center;
  color: #FFFFFF;
  text-align: center;
}

.dwolla-iav-header {
  font-size: 16px;
  line-height: 21px;
  color: #101011;
  font-family: PublicSans-Bold;
}

.dwolla-iav-link {
  font-size: 15px;
  line-height: 24px;
  color: #58585B;
  font-family: PublicSans-Regular;
}

.footnote .dwolla-iav-link {
  font-size: 10px;
  line-height: 14px;
  color: #58585B;
  font-family: PublicSans-Regular;
}

.dwolla-iav-label {
  font-size: 14px;
  line-height: 17px;
  color: #101011;
  font-family: PublicSans-Regular;
}

.dwolla-iav-radio-selected {
  background-color: rgb(16, 57, 221);
}
`;

export const Image = styled.img`
  float: right;
  margin: 10px;
`;